import { Divider, Modal } from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';

import './popup.css';

const Popup = ({
  setOpen,
  open,
  title,
  body,
  footer,
}) => (
  <div id="modal">
    <Modal
      hideFade
      footerSlot={footer}
      headerSlot={(
        <div
          className="ncss-container"
          id="modal-header"
          style={{ minWidth: '400px' }}
        >
          <div className="ncss-row d-sm-flx flx-ai-sm-c mb3-sm">
            <div className="ncss-col-sm-12 ta-sm-c">
              <h1 className="eds-type--title-6">{title}</h1>
            </div>
          </div>
          <Divider />
        </div>
        )}
      isOpen={open}
      onDismiss={() => setOpen(!open)}
    >
      <div className="ncss-container modal-body">
        <div className="ncss-row list">
          <div className="ncss-col-sm-12 ta-sm-l">
            {body}
          </div>
        </div>
      </div>
    </Modal>
  </div>
  );

Popup.propTypes = {
  body: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default Popup;
